import { render, staticRenderFns } from "./MenuItemsEditor.vue?vue&type=template&id=d4dd1588&scoped=true&"
import script from "./MenuItemsEditor.vue?vue&type=script&lang=js&"
export * from "./MenuItemsEditor.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemsEditor.vue?vue&type=style&index=0&id=d4dd1588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dd1588",
  null
  
)

export default component.exports